import type { GameMeta } from '@gmp/game-sdk';

export const doubleAgentMeta = {
  id: 'double-agent',
  name: 'Double Agent',
  tagline: 'An incompetent spy agency, a few double agents, and a lot of very important pudding.',
  description:
    'Everyone is secretly Agency or a double agent, with a private objective. Each mission, every spy quietly picks one covert action: support, sabotage, investigate, protect, divert or plant a decoy. Read the intel report, then cast a secret vote to burn a suspect. The Agency needs 3 clean missions; the doubles need 3 sabotaged ones. No chatting required: play over lunch or over a week.',
  minPlayers: 4,
  maxPlayers: 12,
  estimatedMinutes: [15, 30],
  usesMedia: false,
  modes: [{ id: 'missions', name: 'Five missions', description: 'Best of five missions (or three on Short). Burn every double agent to win early.' }],
  theme: { primary: '#d9c27a', secondary: '#c8343c', background: '#14161a', ink: '#f2ead3' },
  readiness: 'beta',
  genre: 'Hidden roles and spy bluffing',
  controls: 'tap',
  category: 'async',
  asyncInfo: {
    turnSeconds: [20, 60],
    match: { quick: '15–30 min', daily: '5–10 days' },
    difficulty: 'medium',
    tags: ['hidden roles', 'deduction', 'bluffing'],
  },
  instructions: [
    { icon: 'EyeOff', title: 'Open your dossier', body: 'You are Agency or a double agent (doubles know each other). You also get a secret objective and one-use tokens.' },
    { icon: 'Hand', title: 'Pick a covert action', body: 'Every mission, everyone secretly picks one: support, sabotage, investigate, protect, divert or plant a decoy. Missed it? You support.' },
    { icon: 'BookOpen', title: 'Read the intel', body: 'The report shows how many sabotages hit the mission. Investigators privately learn if their target acted Hostile (unless a decoy lied).' },
    { icon: 'Vote', title: 'Burn a suspect', body: 'Secret vote: a strict majority burns a player, revealing their side. Agency wins 3 clean missions or burns every double; doubles win 3 sabotaged missions.' },
  ],
} satisfies GameMeta;
